function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#FFF",
  stroke: "#000",
  strokeOpacity: 0.2,
  strokeWidth: 0.5,
  d: "M21.997 15.75H22c.955.008 1.74-.773 1.751-1.746V2.006a1.789 1.789 0 00-.52-1.25A1.72 1.72 0 0021.997.25H2.001A1.718 1.718 0 00.77.757c-.33.33-.517.779-.521 1.247v11.99c.004.47.191.92.52 1.25.329.328.771.51 1.233.506h19.994zm0 .5h-.002.002z"
}), React.createElement("path", {
  fill: "#0165AC",
  d: "M10.002 2.052v-.016h4v.016a6 6 0 010 11.968v.016h-4v-.016a6 6 0 010-11.968z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M11.602 11.428a3.6 3.6 0 000-6.784v6.784zm-2.4-6.784a3.6 3.6 0 000 6.784V4.644zm1.2 8.592a5.2 5.2 0 110-10.4 5.2 5.2 0 010 10.4z"
}));

var SvgDiners = function SvgDiners(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDiners, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/diners.0121dd88.svg";
export { ForwardRef as ReactComponent };